import _ from "lodash";
/**
 * Cuida das rotina de expressoes
 * @class
 */
export class BrainTools {
    /**
     * @public
     * Quebra a expressão por serieId
     * @param {String} exp
     */
    expressionSplit(exp) {
        return exp.match(/\[(.+?)\]/g);
    }

    /**
     * @public
     * Remove da expressão as rules |{}|
     * @param {String} exp
     */
    rulesRemove(exp) {
        const terms = exp.match(/\[(.*?)\]/g);

        if (terms.length) {
            terms.forEach((term) => {
                exp = exp.replace(term, this.serieIdExtract(term));
            });
        }

        return exp;
    }

    /**
     * @private
     * Retona a re
     * @param {String} term
     */
    ruleExtract(term) {
        let rule = _.nth(term.split(/\|/), 1);
        if (rule) {
            rule = rule.replace(/\[|\]/g, "").replace(/\'/g, '"');
            try {
                rule = JSON.parse(rule);
            } catch (ex) {
                console.error(term, rule, ex);
            }
        }
        return rule;
    }

    /**
     * Subistiui serie
     * @param {String} serieId
     */
    serieExchangeReference(serieId) {
        return new RegExp(serieId.replace(/(\[|\])/g, "\\$1"));
    }

    /**
     * @private
     * Extrai as regras da maquina
     * @param {String}
     *
     * @return {Array}
     */
    serieIdExtract(variable) {
        let [serieId] = variable.split(/\|/);

        return serieId.replace(/\[|\]/g, "");
    }

    /**
     * Remove valores indesejados
     * @param {String} serieId
     */
    specialCharacterRemove(serieId) {
        return serieId.replace(/\[|\]/g, "");
    }
}
